import { takeLatest, put, call } from 'redux-saga/effects';

import { listContaCaixaCadastro } from '../service';
import {
  TABLE_CONTA_CAIXA_CADASTRO,
  TABLE_CONTA_CAIXA_CADASTRO_PENDING,
  TABLE_CONTA_CAIXA_CADASTRO_SUCCESS,
  TABLE_CONTA_CAIXA_CADASTRO_FAILURE
} from '../actionTypes';

function* sagaListContaCaixaCadastro(action) {
  yield put({ type: TABLE_CONTA_CAIXA_CADASTRO_PENDING })

  try {
    const table = yield call(listContaCaixaCadastro, action.args)
    yield put({ type: TABLE_CONTA_CAIXA_CADASTRO_SUCCESS, table: table })

  } catch (error) {

    yield put({ type: TABLE_CONTA_CAIXA_CADASTRO_FAILURE })
    // console.error(error) // eslint-disable-line

  }
}

export default function* watchListContaCaixaCadastro() {
  yield takeLatest(TABLE_CONTA_CAIXA_CADASTRO, sagaListContaCaixaCadastro)
}